/**
 * Centralized enum/value → configuration for the Badge component (`color`, i18n keys, etc.).
 * Add new exported helpers here as reusable badge mappings are needed.
 */
import { DEFAULT_EMPTY_VALUE } from '@/utils/constants';
import { CoreEnums } from '@/utils/domain/constants';

const { InternalTaskStatus, OperationResultStatus } = CoreEnums;

export function getOperationResultStatusProcessBadgeStatus(status) {
  if (status == null || status === '') return 'default';
  const resolved =
    typeof status === 'string' && status.trim() !== '' && !Number.isNaN(Number(status))
      ? Number(status)
      : status;
  if (typeof resolved === 'number' && !Number.isFinite(resolved)) return 'default';
  const byStatus = {
    [OperationResultStatus.Pending]: 'pending',
    [OperationResultStatus.Executing]: 'processing',
    [OperationResultStatus.Success]: 'approved',
    [OperationResultStatus.Error]: 'rejected',
    [OperationResultStatus.Failed]: 'rejected',
  };
  return byStatus[resolved] ?? 'default';
}

/** Maps InternalTaskStatus to Badge `color` + i18n id for `statusText`. */
export const getInternalTaskStatusBadgeConfig = (status) => {
  if (status === null || status === undefined) {
    return { value: DEFAULT_EMPTY_VALUE, badge: null };
  }

  const resolved =
    typeof status === 'string' && status.trim() !== '' && !Number.isNaN(Number(status))
      ? Number(status)
      : status;

  const statusConfig = {
    [InternalTaskStatus.Pending]: {
      color: 'execution',
      statusText: 'internalTaskStatus.pending',
    },
    [InternalTaskStatus.Processing]: {
      color: 'execution',
      statusText: 'internalTaskStatus.processing',
    },
    [InternalTaskStatus.Processed]: {
      color: 'approved',
      statusText: 'internalTaskStatus.processed',
    },
    [InternalTaskStatus.Error]: {
      color: 'rejected',
      statusText: 'internalTaskStatus.error',
    },
    [InternalTaskStatus.Skipped]: {
      color: 'default',
      statusText: 'internalTaskStatus.skipped',
    },
    [InternalTaskStatus.Cancelled]: {
      color: 'default',
      statusText: 'internalTaskStatus.cancelled',
    },
    [InternalTaskStatus.Failed]: {
      color: 'rejected',
      statusText: 'internalTaskStatus.failed',
    },
  };

  return (
    statusConfig[resolved] ||
    statusConfig[status] || {
      color: 'default',
      statusText: 'internalTaskStatus.unknown',
    }
  );
};
